import { HttpClient, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  Injector,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { SeAnalyticsModule } from 'se-analytics';
import { SeFeAuthSupportModule } from 'se-fe-auth-support';
import { SeFeFrameRouterConfig, SeFeFrameRouterModule } from 'se-fe-frame-router';

import { environment } from '../environments/environment';
import { appInitializerFactory, HttpLoaderFactory } from './app.module';
import { appRoutes } from './app.routes';
import { baseHrefProvider } from './core/providers/base-href.provider';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection(),
    provideRouter(appRoutes),
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    baseHrefProvider,
    provideAppInitializer(() => {
      const initializerFn = appInitializerFactory(inject(TranslateService), inject(Injector));
      return initializerFn();
    }),
    importProvidersFrom(
      SeFeFrameRouterModule.forRoot({
        origin: environment.frameRouterOrigin,
        redirectUrl: environment.frameRouterRedirectUrl,
      } as SeFeFrameRouterConfig),
      SeFeAuthSupportModule.forRoot(environment),
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      }),
      SeAnalyticsModule.forRoot({
        platProp: 'se_financial_reports_ui',
        platformSubSec: 'HQ',
        currentEnv: environment.name,
      })
    ),
  ],
};
